import React, { Component } from 'react';
import displayName from 'component-lib/displayName';

import styles from './AppHeader.scss';

export default function MenuCloseHoverHandler(WrappedComponent) {
    return class MenuCloseHoverHandlerComponent extends Component {
        static displayName = displayName('AppHeader/MenuCloseHoverHandler');

        constructor(props) {
            super(props);

            this.state = {
                menuClassName: '',
            };
        }

        hideMenu = (fn) => {
            fn();
            this.setState({ menuClassName: styles['no-hover'] });
        };

        showMenu = () => { this.setState({ menuClassName: '' }); };

        render() {
            return (
                <WrappedComponent
                    {...this.props}
                    hideMenu={this.hideMenu}
                    showMenu={this.showMenu}
                    menuClassName={this.state.menuClassName}
                />
            );
        }
    };
}
